import { Column, Row } from "../../containers";
import { LilChequeProps } from "./types";
import { usePopupStore, useThemeStore } from "../../../stores";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Heading } from "../../typography";
import {
  CalendarIcon,
  FinanceIcon,
  HistoryIcon,
  NumberIcon,
} from "../../../assets/icons";
import { addComma, chequeStatusToString, getDateStr } from "../../../utils";
import ChequeDetails from "../cheque-details";

const LilCheque = <T extends {}>(props: LilChequeProps<T>) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const {
    background = theme.overlay,
    className = "",
    style = {},
    props: p,
  } = props;

  const color =
    background === theme.overlay ? theme.textOnOverlay : theme.textOnBg;

  const onClick = (): void => {
    setPopupBody(<ChequeDetails updateCb={props.updateCb} {...props} />);
  };

  return (
    <Column
      style={{
        width: 140,
        height: 150,
        borderRadius: 15,
        padding: 10,
        overflow: "hidden",
        cursor: "pointer",
        ...style,
      }}
      background={background}
      justifyContent={JustifyContent.Evenly}
      alignItems={AlignItems.Start}
      className={className}
      props={{ onClick, ...p }}
    >
      <Heading size={16} color={color}>
        {props.name}
      </Heading>

      <Row gap={10}>
        <NumberIcon />
        <Heading size={12} color={color}>
          {props.number}
        </Heading>
      </Row>

      <Row gap={10}>
        <CalendarIcon />
        <Heading size={12} color={color}>
          {getDateStr(props.date)}
        </Heading>
      </Row>

      <Row gap={10}>
        <HistoryIcon />
        <Heading size={12} color={color}>
          {chequeStatusToString(props.status)}
        </Heading>
      </Row>

      <Row gap={10}>
        <FinanceIcon />
        <Heading size={12} color={color}>
          {addComma(props.price)}
        </Heading>
      </Row>
    </Column>
  );
};

export default LilCheque;
